module.exports = __webpack_public_path__ + "static/media/ZAPTalent-PDF-Header.0ced3987.png";